/*
  sidebar の portfolio 表示順を API 経由で永続化する。
*/
import { AuthTokenExpiredException } from '@pkg/basic'
import { apiClient } from '../constants'

/**
 * moved item と前後 neighbor を使って表示順変更を保存する。
 */
export const updatePortfolioDisplayOrder = async (params: {
  getToken: () => Promise<string | null>
  movedPortfolioUuid: string
  previousPortfolioUuid?: string
  nextPortfolioUuid?: string
}): Promise<void> => {
  const {
    getToken,
    movedPortfolioUuid,
    previousPortfolioUuid,
    nextPortfolioUuid,
  } = params
  const token = await getToken()
  if (token === null) {
    throw new AuthTokenExpiredException()
  }

  const response = await apiClient.v1.portfolio['display-order'].$post(
    {
      json: {
        movedPortfolioUuid,
        previousPortfolioUuid,
        nextPortfolioUuid,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Failed to update portfolio display order: ${response.status} ${response.statusText}`,
    )
  }
}
